// @ts-nocheck
import { Column } from 'react-table';
import { LucideIconCell } from '../../../feed-tags/tags-table/ui/LucideIconCell';
import { PostCustomCell } from './PostCustomCell';
import { PostCustomHeader } from './PostCustomHeader';
import { PostPublicationCell } from './PostPublicationCell';

const getLang = (obj: Record<string, string> | undefined, lang: string): string => {
	if (!obj) return '';
	return obj[lang] || obj['ru'] || Object.values(obj)[0] || '';
};

const postsColumns = (lang: string): ReadonlyArray<Column<PostDto>> => [
	{
		Header: props => (
			<PostCustomHeader
				tableProps={props}
				title='UUID'
				className='min-w-125px'
			/>
		),
		id: 'uuid',
		Cell: ({ ...props }) => (
			<PostCustomCell value={props.data[props.row.index]?.uuid} />
		),
	},

	{
		Header: props => (
			<PostCustomHeader
				tableProps={props}
				title='Имя'
				className='min-w-100px'
			/>
		),
		id: 'name',
		Cell: ({ ...props }) => (
			<PostCustomCell value={getLang(props.data[props.row.index]?.name, lang)} />
		),
	},
	{
		Header: props => (
			<PostCustomHeader
				tableProps={props}
				title='Тег'
				className='min-w-100px'
			/>
		),
		id: 'tag',
		Cell: ({ ...props }) => (
			<PostCustomCell value={getLang(props.data[props.row.index]?.tag, lang)} />
		),
	},
	{
		Header: props => (
			<PostCustomHeader
				tableProps={props}
				title='Иконка'
				className='min-w-100px'
			/>
		),
		id: 'icon',
		Cell: ({ ...props }) => (
			<LucideIconCell name={props.data[props.row.index]?.icon} />
		),
	},
	{
		Header: props => (
			<PostCustomHeader
				tableProps={props}
				title='Telegram'
				className='min-w-100px'
			/>
		),
		id: 'publication',
		Cell: ({ ...props }) => (
			<PostPublicationCell
				publication={props.data[props.row.index]?.publication}
			/>
		),
	},
];

export { postsColumns };
